export const keys = [
	['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'],
	['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L'],
	['⏎', 'Z', 'X', 'C', 'V', 'B', 'N', 'M', '⌫'],
	['ENTER', 'BACKSPACE'],
];

export const guessKeys = [1, 2, 3, 4, 5, 6];

export default keys;
